export const NotShowIcon = (id: string) => {
  return ![
    "ec775675-6ca8-4404-a89d-5830ae60fb6c",
    "590b42f9-02cd-4269-b9d3-d35c4a7c0e5c",
    "cb8aca08-9ff8-42f1-9828-2e3f78079878",
    "9b42a036-4be5-43ee-82a2-0b874c49592f",
  ].includes(id);
};

export const IsOfferWeek = (id: string) => {
  return [
    "ec775675-6ca8-4404-a89d-5830ae60fb6c",
    "590b42f9-02cd-4269-b9d3-d35c4a7c0e5c",
    "cb8aca08-9ff8-42f1-9828-2e3f78079878",
    "9b42a036-4be5-43ee-82a2-0b874c49592f",
  ].includes(id);
};
